/**
 * This is just an example file and can be removed once real reducers are in place
 */

import { ReduxSlices } from 'floorplan-v2/app/appRoot/types';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DraggedBookingSourceEnum, IDragBookingInfoForModal, IDragTableBookingSlot, ITableDragState } from './types';
import { IBooking } from 'shared-types/SharedTypes';
import { FloorplanV2State } from 'floorplan-v2/app/appRoot/rootReducer';

const initialState: ITableDragState = {
  dragFromTableId: '',
  dragToTableId: '',
  dragCompleteTableId: '',
  dragFromTableBookingSlot: null,
  dragToTableBookingSlot: null,
  draggedBookingPoint: null,
  draggedBooking: null,
  bookingToSwap: null,
  bookingConfirmDialogWL: null,
  dragBookingInfoForModal: null,
  draggedBookingSource: DraggedBookingSourceEnum.Table,
  isLongTouch: false,
  isDragActionComplete: false,
  isDragSaveActionComplete: false,
};

export const updateDraggedBookingPoint = createAsyncThunk(
  'tableDrag/updateDraggedBookingPoint',
  async(payload: {x: number, y: number}, {dispatch, getState}): Promise<any> => {
    const state = getState() as FloorplanV2State;
    if (state.floorplanTableDragReducer.draggedBooking) {
      return payload;
    } else {
      return null;
    }
  }
)

const tableDragSlice = createSlice({
  name: ReduxSlices.TableDrag,
  initialState,
  reducers: {
    setDragFromTableId: (state: ITableDragState, action: PayloadAction<string>) => {
      state.dragFromTableId = action.payload;
    },
    setDragToTableId: (state: ITableDragState, action: PayloadAction<string>) => {
      state.dragToTableId = action.payload;
    },
    setDragCompleteTableId: (state: ITableDragState, action: PayloadAction<string>) => {
      state.dragCompleteTableId = action.payload;
    },
    setDragFromTableBookingSlot: (state: ITableDragState, action: PayloadAction<IDragTableBookingSlot>) => {
      state.dragFromTableBookingSlot = action.payload;
    },
    setDragToTableBookingSlot: (state: ITableDragState, action: PayloadAction<IDragTableBookingSlot>) => {
      state.dragToTableBookingSlot = action.payload;
    },
    setDraggedBookingPoint: (state, action: PayloadAction<{x: number, y: number}>) => {
      state.draggedBookingPoint = action.payload;
    },
    resetDraggedBookingPoint: (state) => {
      state.draggedBookingPoint = null;
    },
    setDraggedBooking: (state, action: PayloadAction<IBooking>) => {
      state.draggedBooking = action.payload;
    },
    resetDraggedBooking: (state) => {
      state.draggedBooking = null;
    },
    setBookingToSwap: (state, action: PayloadAction<IBooking>) => {
      state.bookingToSwap = action.payload;
    },
    resetBookingToSwap: (state) => {
      state.bookingToSwap = null;
    },
    setIsShownBookingConfirmWL: (state, action: PayloadAction<{draggedBooking?: IBooking, dragToTableId?: string}>) => {
      if (!action.payload.draggedBooking) {
        state.bookingConfirmDialogWL = null
        return;
      }
      state.bookingConfirmDialogWL = action.payload;
    },
    setDragBookingInfoForModal: (state, action: PayloadAction<IDragBookingInfoForModal>) => {
      state.dragBookingInfoForModal = action.payload;
      if (!action.payload?.draggedBooking) {
        state.dragBookingInfoForModal = null
        return;
      }
      state.dragBookingInfoForModal = action.payload;
    },
    setDraggedBookingSource: (state, action: PayloadAction<DraggedBookingSourceEnum>) => {
      state.draggedBookingSource = action.payload;
    },
    setIsLongTouch: (state, action: PayloadAction<boolean>) => {
      state.isLongTouch = action.payload;
    },
    setIsDragSaveActionComplete: (state, action: PayloadAction<boolean>) => {
      state.isDragSaveActionComplete = action.payload;
    },
    setIsDragActionComplete: (state, action: PayloadAction<boolean>) => {
      state.isDragActionComplete = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(updateDraggedBookingPoint.fulfilled, (state, action) => {
      state.draggedBookingPoint = action.payload;
    });
  }
});

// Extract the action creators object and the reducer
const { actions, reducer } = tableDragSlice;
// Extract and export each action creator by name
export { actions as tableDragActions };
// Export the reducer, either as a default or named export
export default reducer;
